import { TidalRateConfigState, TidalRateConfigAction } from './types'

export const initialState: TidalRateConfigState = {
  config: undefined,
  uuid: undefined,
  loading: false,
  updating: false,
}

export function TidalRateConfigReducer(
  state = initialState,
  action: TidalRateConfigAction
) {
  switch (action.type) {
    case 'TIDAL_RATE_CONFIG_SET_LOADING':
      return { ...state, loading: action.loading }
    case 'TIDAL_RATE_CONFIG_SET_UPDATING':
      return { ...state, updating: action.updating }
    case 'TIDAL_RATE_CONFIG_SET_ERROR':
      return { ...state, error: action.error }
    case 'TIDAL_RATE_CONFIG_SET':
      return {
        ...state,
        config: action.config,
        uuid: action.uuid,
        error: undefined,
        loading: false,
      }
    default:
      return state
  }
}

export default TidalRateConfigReducer
